module.exports = "#map_canvas {\r\n    height: 60vh;\r\n    width: 90vw;\r\n    position: relative; \r\n    top: 0; \r\n    bottom: 0; \r\n    left: 0; \r\n    right: 0; \r\n    z-index: 0;\r\n}\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/tecnico/mapa-tecnico/mapa-tecnico.component.css
// module id = ./src/app/tecnico/mapa-tecnico/mapa-tecnico.component.css
// module chunks = main